import { getGlobalObject } from './global';
// TODO: Implement different loggers for different environments
var global = getGlobalObject();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/**
 * Temporarily unwrap `console.log` and friends in order to perform the given callback using the original methods.
 * Restores wrapping after the callback completes.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
export function consoleSandbox(callback) {
  var global = getGlobalObject();
  var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
  if (!('console' in global)) {
    return callback();
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  var originalConsole = global.console;
  var wrappedLevels = {};
  // Restore all wrapped console methods
  levels.forEach(function (level) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (level in global.console && originalConsole[level].__sentry_original__) {
      wrappedLevels[level] = originalConsole[level];
      originalConsole[level] = originalConsole[level].__sentry_original__;
    }
  });
  // Perform callback manipulations
  var result = callback();
  // Revert restoration to wrapped state
  Object.keys(wrappedLevels).forEach(function (level) {
    originalConsole[level] = wrappedLevels[level];
  });
  return result;
}
/** JSDoc */
var Logger = /** @class */function () {
  /** JSDoc */
  function Logger() {
    this._enabled = false;
  }
  /** JSDoc */
  Logger.prototype.disable = function () {
    this._enabled = false;
  };
  /** JSDoc */
  Logger.prototype.enable = function () {
    this._enabled = true;
  };
  /** JSDoc */
  Logger.prototype.log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (!this._enabled) {
      return;
    }
    consoleSandbox(function () {
      global.console.log(PREFIX + "[Log]: " + args.join(' '));
    });
  };
  /** JSDoc */
  Logger.prototype.warn = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (!this._enabled) {
      return;
    }
    consoleSandbox(function () {
      global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
    });
  };
  /** JSDoc */
  Logger.prototype.error = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (!this._enabled) {
      return;
    }
    consoleSandbox(function () {
      global.console.error(PREFIX + "[Error]: " + args.join(' '));
    });
  };
  return Logger;
}();
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());
export { logger };